import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unassigned: {
		id: 'issue-history.history-items.history-item.assignee-history-item.assignee.unassigned',
		defaultMessage: 'Unassigned',
		description: 'Describes that a user has unassigned somebody from the issue.',
	},
});
